import { PublishingV2InfoForm } from "./PublishingV2InfoForm";

export default PublishingV2InfoForm;
